import React from "react";
import { useTranslation } from "react-i18next";
import { Smartphone } from "lucide-react";
export default function PermissionModal({ isOpen, onAllow, onDeny }) {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div className="shake-sheet-overlay">
      <div
        className="shake-reward-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="shake-permission-title"
      >
        <div className="shake-modal-icon">
          <Smartphone size={30} aria-hidden="true" />
        </div>
        <h2 id="shake-permission-title">{t("game.startShake")}</h2>
        <p>{t("game.motionHint")}</p>
        <button className="shake-game-button" onClick={onAllow}>
          {t("permission.allow")}
        </button>
        <button className="shake-secondary-button" onClick={onDeny}>
          {t("permission.deny")}
        </button>
      </div>
    </div>
  );
}
